import type { ItemRole } from './vocabulary.ts'

export type RoleSource = 'manual' | 'sheet' | 'name'

export type ResolvedRole = { role: ItemRole; source: RoleSource } | undefined

/** A choice made in the UI beats the sheet, which beats a guess from the item's name. */
export const resolveItemRole = (candidates: Partial<Record<RoleSource, ItemRole>>): ResolvedRole => {
  for (const source of ['manual', 'sheet', 'name'] as const) {
    const role = candidates[source]
    if (role) {
      return { role, source }
    }
  }
  return undefined
}
